<template lang="pug">
#navigation
  transition(name="slideDown")
    b-img.mb-4(
      v-if="showIcon",
      fluid,
      width="150",
      :src="require('../assets/me.png')",
      alt="Profile picture"
    )
  h1.mb-3 {{ me.name }}
  p.mb-4 {{ me.title }}
  transition(name="slideUp")
    div(v-if="showNav")
      .d-flex.d-md-block.mb-4.align-items-center.justify-content-center.flex-wrap
        b-button.px-2.px-md-0.text-center.text-md-left.d-block(
          variant="link",
          v-for="link in links",
          :key="link.title",
          exact,
          :to="link.route"
        ) {{ link.title }}
        b-button.px-2.px-md-0.text-center.text-md-left.d-block(
          variant="link",
          href="/guido-ruiz-resume.pdf",
          target="_blank"
        ) 
          .d-flex.align-items-center
            v-icon.mr-1(name="download")
            span Resume
      .d-flex.d-md-block.m-n1.align-items-center.justify-content-center.flex-wrap
        b-button.round-link.m-1.d-inline-flex.align-items-center.justify-content-center(
          v-for="item in items",
          :key="item.key",
          :variant="item.variant",
          :href="item.url",
          target="_blank"
        )
          v-icon(:name="item.icon")
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "Navigation",
  data: () => ({
    showIcon: false,
    showNav: false,
    links: [
      {
        title: "About",
        route: "/",
      },
      {
        title: "Skills",
        route: "/skills",
      },
      {
        title: "Experience",
        route: "/experience",
      },
    ],
  }),
  computed: {
    ...mapState(["me"]),
    items() {
      return this.me.socials;
    },
  },
  mounted() {
    this.showIcon = true;
    this.showNav = true;
  },
};
</script>

<style lang="scss">
#navigation {
  .nav-link button {
    padding-left: 0 !important;
    margin-left: 0 !important;
  }
  .round-link {
    width: 40px;
    height: 40px;
    border-radius: 20px;
    padding: 0;
  }
}
</style>
